import { components, primitives, resolve } from "@baton/tokens";

/**
 * A pixel token as a number, for the geometry Motion animates in pixels: the Spectrum UI
 * Animated Switch's knob, the Avatar Stack's overlap and fan and the Kbd Key's press depth
 * (2026-09-15, by the owner's decision). Reading the token keeps `packages/tokens` the one
 * source of those lengths; a token that is not a pixel length is an error rather than a guess.
 */
export function pixels(name: string): number {
  const value = resolve({ ref: name }, components, primitives);
  const match = /^(\d+(?:\.\d+)?)px$/.exec(value);
  if (match?.[1] === undefined) throw new Error(`--${name} is not a pixel length: ${value}`);
  return Number(match[1]);
}

/** A unitless component token as a number, such as the Avatar Stack's overlap fraction. */
export function ratio(name: string): number {
  const value = Number(resolve({ ref: name }, components, primitives));
  if (Number.isNaN(value)) throw new Error(`--${name} is not a number`);
  return value;
}

